<template>
    <div class="purchase-layout">
        <!-- 主内容区 -->
        <div class="main-content">
            <!-- 生产任务查询区 -->
            <el-form :inline="true" :model="searchForm" class="task-search-form">
                <el-form-item label="订单编号">
                    <el-input v-model="searchForm.orderNo" placeholder="订单编号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <!-- 修改1：绑定前端查询方法 -->
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button @click="resetTaskSearch" icon="el-icon-refresh">重置</el-button>
                    <el-button type="primary" @click="openAddPurchaseDialog" icon="el-icon-plus">新增采购单</el-button>
                </el-form-item>
            </el-form>

            <!-- 任务清单表格 -->
            <!-- 修改2：表格数据绑定过滤后的分页列表 -->
            <el-table ref="taskTable" :data="paginatedFilteredTaskList" border style="width: 100%; margin-top: 20px"
                @row-click="handleTaskRowClick" height="70vh">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="index" label="序号" width="70" align="center"></el-table-column>
                <el-table-column prop="orderNo" label="采购订单编号" align="center"></el-table-column>
                <el-table-column prop="orderStatus" label="订单状态" align="center"></el-table-column>
                <el-table-column prop="orderDate" label="采购订单时间" align="center"></el-table-column>
                <!-- <el-table-column prop="totalPrice" label="总价" align="center"></el-table-column> -->
                <el-table-column prop="status" label="物料采购单发布状态" align="center">
                    <template #default="scope">
                        <el-tag :type="scope.row.status === 1 ? 'info' : 'success'">
                            {{ scope.row.status == 1 ? '未发布' : '已发布' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="500">
                    <template #default="scope">
                        <el-button size="mini" type="warning" @click="initiatePurchase(scope.row)" icon="el-icon-edit"
                            :disabled="scope.row.status === 2">
                            修改原料
                        </el-button>
                        <el-button size="mini" type="success" @click="InitiateProcurement(scope.row)"
                            :disabled="scope.row.status === 2">
                            发起采购
                        </el-button>
                        <el-button size="mini" type="primary" @click="openEditDialog(scope.row)" icon="el-icon-edit"
                            :disabled="scope.row.status === 2">
                            修改
                        </el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="deletePurchaseOrders(scope.row)" :disabled="scope.row.status === 2">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 任务清单分页 -->
            <div style="margin-top: 20px; text-align: center;">
                <!-- 修改3：分页总数绑定过滤后的列表长度 -->
                <el-pagination @size-change="handleTaskSizeChange" @current-change="handleTaskCurrentChange"
                    :current-page="taskCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="taskPageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="filteredTaskList.length"
                    background></el-pagination>
            </div>

            <!-- 原料需求抽屉 -->
            <el-drawer title="原料需求列表" :visible.sync="materialDrawerVisible" placement="right" size="60%"
                :close-on-click-modal="false" :append-to-body="true" custom-class="material-drawer">
                <el-table :data="currentMaterialDemand" border style="width: 100%">
                    <el-table-column prop="materialName" label="原料名称" align="center"></el-table-column>
                    <el-table-column prop="lackNum" label="缺失原料数量" align="center"></el-table-column>
                    <el-table-column prop="surplusNum" label="剩余原料数量" align="center"></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer" style="margin-top: 20px; text-align: right;">
                    <el-button @click="materialDrawerVisible = false">关闭</el-button>
                </div>
            </el-drawer>

            <!-- 发起采购抽屉（支持原料增删改） -->
            <el-drawer title="修改采购单" :visible.sync="purchaseDialogVisible" placement="right" size="90%"
                :close-on-click-modal="false" :append-to-body="true" custom-class="purchase-drawer">
                <el-form :model="purchaseForm" :rules="purchaseFormRules" ref="purchaseFormRef" label-width="120px"
                    class="mt-4">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="订购时间" prop="orderDate">
                                <el-date-picker v-model="purchaseForm.orderDate" type="datetime" placeholder="选择订购时间"
                                    style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="总价" prop="totalPrice">
                                <el-input v-model="purchaseForm.totalPrice" placeholder="总价" disabled
                                    readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 原料及供应商表格 -->
                    <el-table :data="purchaseMaterials" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="index" label="序号" width="100" align="center"></el-table-column>
                        <el-table-column prop="materialName" label="原料名称" align="center">
                            <template #default="scope">
                                <el-select v-model="scope.row.materialName" placeholder="选择原料名称"
                                    :disabled="!scope.row.isEditing" @change="handleMaterialChange(scope.row)">
                                    <el-option v-for="material in materialList" :key="material.value"
                                        :label="material.label" :value="material.label"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="num" label="采购数量" align="center">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.num" :min="0.1" :step="0.1" placeholder="采购数量"
                                    :disabled="!scope.row.isEditing"
                                    @change="handleWeightChange(scope.row)"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column prop="unit" label="单位" align="center">
                            <template #default="scope">
                                <el-select v-model="scope.row.unit" placeholder="选择单位" :disabled="!scope.row.isEditing">
                                    <el-option label="克" value="g"></el-option>
                                    <el-option label="千克" value="kg"></el-option>
                                    <el-option label="吨" value="t"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <!-- 新增单价列 -->
                        <el-table-column prop="unitPrice" label="单价" align="center">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.unitPrice" :min="0.01" :step="0.01" placeholder="单价"
                                    :disabled="!scope.row.isEditing" @change="handlePriceChange(scope.row)"
                                    precision="2"></el-input-number>
                            </template>
                        </el-table-column>
                        <!-- 新增总价列 -->
                        <el-table-column prop="totalPrice" label="总价" align="center">
                            <template #default="scope">
                                <span>{{ scope.row.totalPrice ? scope.row.totalPrice.toFixed(2) : '0.00' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="supplierId" label="供应商" align="center">
                            <template #default="scope">
                                <el-select v-model="scope.row.supplierId" placeholder="请选择供应商"
                                    :disabled="!scope.row.isEditing">
                                    <el-option v-for="supplier in suppliers" :key="supplier.supplierId"
                                        :label="supplier.supplierName" :value="supplier.supplierId"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="240">
                            <template #default="scope">
                                <el-button size="mini" type="text" icon="el-icon-edit"
                                    @click="startEditMaterial(scope.row)" :disabled="scope.row.isEditing">
                                    编辑
                                </el-button>
                                <el-button size="mini" type="text" icon="el-icon-check"
                                    @click="confirmEditMaterial(scope.row)" :disabled="!scope.row.isEditing">
                                    确认
                                </el-button>
                                <el-button size="mini" type="text" icon="el-icon-delete"
                                    @click="deleteMaterial(scope.row, scope.$index)" :disabled="scope.row.isEditing">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 新增原料按钮 -->
                    <el-button type="primary" icon="el-icon-plus" @click="addNewMaterial" style="margin-top: 15px">
                        新增原料
                    </el-button>
                </el-form>
            </el-drawer>

            <!-- 新增采购单抽屉 -->
            <el-drawer title="新增采购单" :visible.sync="addPurchaseDialogVisible" placement="right" size="90%"
                :close-on-click-modal="false" :append-to-body="true" custom-class="add-purchase-drawer">
                <el-form :model="addPurchaseForm" :rules="addPurchaseFormRules" ref="addPurchaseFormRef"
                    label-width="120px" class="mt-4">
                    <el-form-item label="采购订单编号" prop="orderNo">
                        <el-input v-model="addPurchaseForm.orderNo" placeholder="采购订单编号"></el-input>
                    </el-form-item>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="采购员" prop="purchaser">
                                <el-input v-model="addPurchaseForm.purchaser" placeholder="采购员"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="订购时间" prop="orderDate">
                                <el-date-picker v-model="addPurchaseForm.orderDate" type="datetime" placeholder="选择订购时间"
                                    style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="总价" prop="totalPrice">
                                <el-input v-model="addPurchaseForm.totalPrice" placeholder="总价" disabled
                                    readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="订单状态" prop="orderStatus">
                                <el-select v-model="addPurchaseForm.orderStatus" placeholder="选择订单状态">
                                    <el-option label="待审批" value="待审批"></el-option>
                                    <el-option label="已审批" value="已审批"></el-option>
                                    <el-option label="已采购" value="已采购"></el-option>
                                    <el-option label="已完成" value="已完成"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 原料及供应商表格 -->
                    <el-table :data="addPurchaseMaterials" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="index" label="序号" width="100" align="center"></el-table-column>
                        <el-table-column prop="materialName" label="原料名称" align="center">
                            <template #default="scope">
                                <el-select v-model="scope.row.materialName" placeholder="选择原料名称">
                                    <el-option v-for="material in materialList" :key="material.label"
                                        :label="material.label" :value="material.label"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="num" label="采购数量" align="center">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.num" :min="0.1" :step="0.1" placeholder="采购数量"
                                    @change="handleAddPurchaseWeightChange(scope.row)"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column prop="unit" label="单位" align="center">
                            <template #default="scope">
                                <el-select v-model="scope.row.unit" placeholder="选择单位">
                                    <el-option label="克" value="g"></el-option>
                                    <el-option label="千克" value="kg"></el-option>
                                    <el-option label="吨" value="t"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <!-- 新增单价列 -->
                        <el-table-column prop="unitPrice" label="单价" align="center">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.unitPrice" :min="0.01" :step="0.01" placeholder="单价"
                                    @change="handleAddPurchasePriceChange(scope.row)" precision="2"></el-input-number>
                            </template>
                        </el-table-column>
                        <!-- 新增总价列 -->
                        <el-table-column prop="totalPrice" label="总价" align="center">
                            <template #default="scope">
                                <span>{{ scope.row.totalPrice ? scope.row.totalPrice.toFixed(2) : '0.00' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="supplierId" label="供应商" align="center">
                            <template #default="scope">
                                <el-select v-model="scope.row.supplierId" placeholder="请选择供应商">
                                    <el-option v-for="supplier in suppliers" :key="supplier.supplierId"
                                        :label="supplier.supplierName" :value="supplier.supplierId"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="150">
                            <template #default="scope">
                                <el-button size="mini" type="danger" icon="el-icon-delete"
                                    @click="removePurchaseMaterial(scope.$index)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-button type="primary" @click="addPurchaseMaterialRow" icon="el-icon-plus"
                        style="margin-top: 15px">
                        新增原料行
                    </el-button>
                    <div style="text-align: right; margin-top: 20px">
                        <el-button @click="addPurchaseDialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitAddPurchase">确认提交</el-button>
                    </div>
                </el-form>
            </el-drawer>

            <!-- 修改采购单抽屉 -->
            <el-drawer title="修改采购单" :visible.sync="editDialogVisible" placement="right" size="60%"
                :close-on-click-modal="false" :append-to-body="true" custom-class="edit-purchase-drawer">
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="120px" class="mt-4">
                    <el-form-item label="采购订单编号" prop="orderNo">
                        <el-input v-model="editForm.orderNo" placeholder="采购订单编号"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态" prop="orderStatus">
                        <el-select v-model="editForm.orderStatus" placeholder="选择订单状态">
                            <el-option label="待审批" value="待审批"></el-option>
                            <el-option label="已审批" value="已审批"></el-option>
                            <el-option label="已采购" value="已采购"></el-option>
                            <el-option label="已完成" value="已完成"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购订单时间" prop="orderDate">
                        <el-date-picker v-model="editForm.orderDate" type="datetime" placeholder="选择采购订单时间"
                            style="width: 100%">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="物料采购单发布状态" prop="status">
                        <el-select v-model="editForm.status" placeholder="选择发布状态">
                            <el-option label="未发布" value="1"></el-option>
                            <el-option label="已发布" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="text-align: right; margin-top: 20px">
                        <el-button @click="editDialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitEdit">确认修改</el-button>
                    </div>
                </el-form>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import {
    getRequiredMaterials,
    addPurchaseOrder,
    deletePurchaseOrder,
    editPurchaseOrder,
    getMaterialByNo,
    editPurchaseMaterial,
    addPurchaseMaterial,
    deletePurchaseMaterial,
    calculateLis,
    publishBidding
} from "@/api/Requirement";
import {
    getSupplierList,
} from "@/api/supplier";
import { getAllProducts } from "@/api/ingredients";
export default {
    data() {
        return {
            // 任务搜索表单
            searchForm: { orderNo: "" },
            // 原始任务列表（全量数据）
            taskList: [],
            // 分页参数
            taskCurrentPage: 1,
            taskPageSize: 10,
            // 供应商列表 (已改为动态加载)
            suppliers: [],
            // 原料列表
            materialList: [],
            // 表单校验规则
            purchaseFormRules: {
                orderDate: [{ required: true, message: "请选择订购时间", trigger: "change" }],
            },
            // 发起采购抽屉控制
            purchaseDialogVisible: false,
            purchaseForm: {
                purchaseUnit: "",
                purchaser: "",
                orderDate: null,
                deliveryTime: "",
                orderNo: "",
                totalPrice: 0.00,
            },
            purchaseMaterials: [],
            // 新增采购单抽屉控制
            addPurchaseDialogVisible: false,
            addPurchaseForm: {
                orderNo: "",
                purchaseUnit: "",
                purchaser: "",
                orderDate: null,
                deliveryTime: "",
                orderStatus: "",
                totalPrice: 0.00,
            },
            addPurchaseMaterials: [
                { index: 1, materialName: "", num: 0.1, unit: "g", unitPrice: 0.01, totalPrice: 0.01, supplierId: "" },
            ],
            addPurchaseFormRules: {
                orderDate: [{ required: true, message: "请选择订购时间", trigger: "change" }],
                orderStatus: [{ required: true, message: "请选择订单状态", trigger: "change" }],
            },
            // 修改采购单抽屉控制
            editDialogVisible: false,
            editForm: {
                id: "",
                orderNo: "",
                orderStatus: "",
                orderDate: null,
                status: "",
            },
            editFormRules: {
                orderNo: [{ required: true, message: "请输入采购订单编号", trigger: "blur" }],
                orderStatus: [{ required: true, message: "请选择订单状态", trigger: "change" }],
                orderDate: [{ required: true, message: "请选择采购订单时间", trigger: "change" }],
                status: [{ required: true, message: "请选择发布状态", trigger: "change" }],
            },
            // 原料需求抽屉控制
            materialDrawerVisible: false,
            currentMaterialDemand: [],
        };
    },
    computed: {
        // 修改4：新增过滤后的任务列表（纯前端筛选）
        filteredTaskList() {
            if (!this.searchForm.orderNo) {
                // 无搜索条件时返回全量数据
                return this.taskList;
            }
            // 按订单编号模糊匹配（不区分大小写）
            const keyword = this.searchForm.orderNo.trim().toLowerCase();
            return this.taskList.filter(item =>
                item.orderNo && item.orderNo.toLowerCase().includes(keyword)
            );
        },
        // 修改5：基于过滤后的列表做分页
        paginatedFilteredTaskList() {
            const startIndex = (this.taskCurrentPage - 1) * this.taskPageSize;
            const endIndex = startIndex + this.taskPageSize;
            return this.filteredTaskList.slice(startIndex, endIndex).map((item, index) => ({
                ...item,
                index: startIndex + index + 1,
            }));
        },
        // 保留原有分页计算（兼容其他逻辑）
        paginatedTaskList() {
            const startIndex = (this.taskCurrentPage - 1) * this.taskPageSize;
            const endIndex = startIndex + this.taskPageSize;
            return this.taskList.slice(startIndex, endIndex).map((item, index) => ({
                ...item,
                index: startIndex + index + 1,
            }));
        },
    },
    mounted() {
        // 初始化加载全量数据
        this.fetchTaskList();
        // 初始化日期为当前时间
        const now = new Date();
        this.addPurchaseForm.orderDate = now;
        this.purchaseForm.orderDate = now;
        this.calculateOrderTotalPrice();
    },
    created() {
        // 组件创建时加载供应商和原料列表
        this.fetchSuppliers();
        this.fetchMaterialList();
    },
    methods: {
        // 修改6：新增纯前端查询方法
        handleSearch() {
            // 重置页码到第一页
            this.taskCurrentPage = 1;
            // 提示搜索结果
            if (this.filteredTaskList.length === 0) {
                this.$message.info(`未找到订单编号包含【${this.searchForm.orderNo}】的采购单`);
            } else {
                this.$message.success(`找到 ${this.filteredTaskList.length} 条匹配的采购单`);
            }
        },
        fetchMaterialList() {
            const userId = localStorage.getItem('userId');
            getAllProducts({ userId })
                .then(response => {
                    const rawMaterials = response.data || [];
                    this.materialList = rawMaterials.map(item => ({
                        label: item.pname,
                        value: item.pid
                    }));
                    console.log("原料列表加载成功:", this.materialList);
                })
                .catch(error => {
                    console.error('获取原料列表失败:', error);
                    this.$message.error('获取原料列表失败，请重试');
                });
        },
        fetchSuppliers() {
            const userId = localStorage.getItem("userId");
            if (!userId) {
                console.error("无法获取用户ID，无法加载供应商列表。");
                this.$message.warning("用户信息无效，请刷新页面。");
                return;
            }
            this.$loading({ text: "正在加载供应商数据..." });
            getSupplierList({ userId: userId })
                .then((response) => {
                    this.suppliers = response.data || [];
                    console.log("供应商列表加载成功:", this.suppliers);
                })
                .catch((error) => {
                    console.error("获取供应商列表失败:", error);
                    this.$message.error("获取供应商数据失败，请稍后重试。");
                    this.suppliers = [];
                })
                .finally(() => {
                    this.$loading().close();
                });
        },
        // 发起采购
        InitiateProcurement(row) {
            publishBidding({ userId: localStorage.getItem('userId'), id: row.id }).then((response) => {
                this.$message.success(response.message);
                // 重新加载全量数据（保证数据最新）
                this.fetchTaskList();
            }).catch(() => {
                this.$message.error("发起采购失败");
            });
        },
        // 生成采购单
        procurement() {
            calculateLis().then((response) => {
                this.$message.success(response.message);
                // 重新加载全量数据
                this.fetchTaskList();
            }).catch(() => {
                this.$message.error("生成采购单失败");
            });
        },
        // 格式化日期
        formatDate(date) {
            if (!date) return "";
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const hour = String(date.getHours()).padStart(2, "0");
            const minute = String(date.getMinutes()).padStart(2, "0");
            const second = String(date.getSeconds()).padStart(2, "0");
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        },
        // 解析日期字符串为Date对象
        parseDate(dateStr) {
            if (!dateStr) return null;
            if (typeof dateStr === 'string') {
                return new Date(dateStr.replace(/-/g, '/'));
            }
            return new Date(dateStr);
        },
        // 修改7：重构fetchTaskList，仅加载全量数据，不处理搜索
        fetchTaskList() {
            this.$loading({ text: "正在加载数据..." });
            const userId = localStorage.getItem("userId");
            const params = { userId: userId };

            // 只加载全量数据，搜索由前端处理
            getRequiredMaterials(params)
                .then((response) => {
                    this.taskList = response.data || [];
                    console.log("全量采购单数据加载成功:", this.taskList);
                })
                .catch(this.handleApiError)
                .finally(() => this.$loading().close());
        },
        // 通用API错误处理
        handleApiError(error) {
            console.error("API调用异常:", error);
            this.$message.error("数据加载失败，请稍后重试。");
            this.taskList = [];
        },
        // 显示原料需求列表
        showMaterialDemand(row) {
            this.$loading({ text: "正在查询数据..." });
            getMaterialByNo({
                userId: localStorage.getItem("userId"),
                orderNo: row.orderNo,
            })
                .then((response) => {
                    const materials = response.data || [];
                    if (materials.length > 0) {
                        this.currentMaterialDemand = materials;
                        this.materialDrawerVisible = true;
                    } else {
                        this.$message.warning("未找到相关物料信息");
                    }
                })
                .catch((error) => {
                    console.error("查询物料需求异常:", error);
                    this.$message.error("查询物料需求失败，请重试");
                })
                .finally(() => {
                    this.$loading().close();
                });
        },
        // 删除采购单
        deletePurchaseOrders(row) {
            this.$confirm("确定要删除该采购单吗？", "确认删除", {
                type: "warning",
            })
                .then(() => {
                    this.$loading({ text: "正在删除..." });
                    deletePurchaseOrder({
                        userId: localStorage.getItem("userId"),
                        id: row.id,
                    })
                        .then((response) => {
                            this.$message.success(response.message || "采购单删除成功");
                            // 删除后重新加载全量数据
                            this.fetchTaskList();
                        })
                        .catch((error) => {
                            console.error("删除采购单异常:", error);
                            this.$message.error("采购单删除失败，请重试");
                        })
                        .finally(() => {
                            this.$loading().close();
                        });
                })
                .catch(() => {
                    this.$message.info("已取消删除");
                });
        },
        // 打开修改抽屉
        openEditDialog(row) {
            this.editForm = {
                ...row,
                orderDate: this.parseDate(row.orderDate)
            };
            this.editDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.editFormRef?.clearValidate();
            });
        },
        // 提交修改采购单
        submitEdit() {
            this.$refs.editFormRef.validate((isValid) => {
                if (isValid) {
                    this.$loading({ text: "正在保存修改..." });
                    const submitData = {
                        ...this.editForm,
                        userId: localStorage.getItem("userId"),
                        orderDate: this.formatDate(this.editForm.orderDate)
                    };
                    editPurchaseOrder(submitData)
                        .then((response) => {
                            this.editDialogVisible = false;
                            this.$message.success(response.message);
                            // 修改后重新加载全量数据
                            this.fetchTaskList();
                        })
                        .catch((error) => {
                            console.error("修改采购单异常:", error);
                            this.$message.error("网络异常，修改失败");
                        })
                        .finally(() => {
                            this.$loading().close();
                        });
                }
            });
        },
        // 修改8：重置搜索（清空条件+重置页码）
        resetTaskSearch() {
            this.searchForm = { orderNo: "" };
            this.taskCurrentPage = 1;
            this.$message.info("搜索条件已重置");
        },
        // 任务分页-每页条数变化
        handleTaskSizeChange(val) {
            this.taskPageSize = val;
            this.taskCurrentPage = 1;
        },
        // 任务分页-页码变化
        handleTaskCurrentChange(val) {
            this.taskCurrentPage = val;
            document.querySelector(".main-content").scrollTop = 0;
        },
        // 任务行点击
        handleTaskRowClick(row) {
            this.$refs.taskTable.toggleRowSelection(row);
        },
        // 发起采购-加载原料列表
        initiatePurchase(row) {
            this.purchaseForm.orderNo = row.orderNo;
            this.$loading({ text: "正在加载原料信息..." });
            getMaterialByNo({
                userId: localStorage.getItem("userId"),
                orderNo: row.orderNo,
            })
                .then((response) => {
                    const materials = response.data || [];
                    console.log(materials);

                    this.purchaseMaterials = materials.map((material, index) => {
                        const unitPrice = material.unitPrice || 0.01;
                        const num = material.num || 0.1;
                        const totalPrice = Number((num * unitPrice).toFixed(2));

                        return {
                            index: index + 1,
                            id: material.id,
                            materialName: material.materialName,
                            num: num,
                            unit: material.unit || "g",
                            unitPrice: unitPrice,
                            totalPrice: totalPrice,
                            supplierId: material.supplier || "",
                            isEditing: false,
                        };
                    });

                    this.calculateOrderTotalPrice('edit');
                    this.purchaseDialogVisible = true;
                    this.$nextTick(() => {
                        this.$refs.purchaseFormRef?.clearValidate();
                    });
                })
                .catch((error) => {
                    console.error("获取采购原料异常:", error);
                    this.$message.error("获取采购原料失败，请重试");
                })
                .finally(() => {
                    this.$loading().close();
                });
        },
        // 发起采购-新增原料
        addNewMaterial() {
            const newIndex = this.purchaseMaterials.length + 1;
            const newMaterial = {
                index: newIndex,
                id: "",
                materialName: "",
                num: 0.1,
                unit: "g",
                unitPrice: 0.01,
                totalPrice: 0.01,
                supplierId: "",
                isEditing: true,
            };
            this.purchaseMaterials.push(newMaterial);
            this.calculateOrderTotalPrice('edit');
        },
        // 计算单行原料总价
        calculateTotalPrice(material) {
            if (material.num && material.unitPrice) {
                material.totalPrice = Number((material.num * material.unitPrice).toFixed(2));
            } else {
                material.totalPrice = 0;
            }

            if (this.purchaseDialogVisible) {
                this.calculateOrderTotalPrice('edit');
            } else if (this.addPurchaseDialogVisible) {
                this.calculateOrderTotalPrice('add');
            }
        },
        // 计算订单总价
        calculateOrderTotalPrice(type = 'add') {
            let materials = [];
            let targetForm = null;

            if (type === 'add') {
                materials = this.addPurchaseMaterials;
                targetForm = this.addPurchaseForm;
            } else if (type === 'edit') {
                materials = this.purchaseMaterials;
                targetForm = this.purchaseForm;
            }

            if (materials.length === 0) {
                targetForm.totalPrice = 0.00;
                return;
            }

            const total = materials.reduce((sum, item) => {
                return sum + (item.totalPrice || 0);
            }, 0);

            targetForm.totalPrice = Number(total.toFixed(2));
        },
        // 发起采购-单价变化
        handlePriceChange(material) {
            this.calculateTotalPrice(material);
        },
        // 发起采购-采购数量变化
        handleWeightChange(material) {
            if (material.num < 0.1) {
                material.num = 0.1;
            }
            this.calculateTotalPrice(material);
        },
        // 新增采购单-单价变化
        handleAddPurchasePriceChange(material) {
            this.calculateTotalPrice(material);
        },
        // 新增采购单-采购数量变化
        handleAddPurchaseWeightChange(material) {
            if (material.num < 0.1) {
                material.num = 0.1;
            }
            this.calculateTotalPrice(material);
        },
        // 发起采购-确认编辑原料
        confirmEditMaterial(material) {
            if (!material.materialName || !material.num || !material.unit || !material.unitPrice || !material.supplierId) {
                this.$message.warning("请完善所有必填项（原料名称、数量、单位、单价、供应商）");
                return;
            }

            this.calculateTotalPrice(material);
            const supplier = this.suppliers.find(s => s.supplierId === material.supplierId) || {};
            const supplierName = supplier.supplierName || "";

            this.$loading({ text: "正在保存原料信息..." });
            const request = material.id
                ? editPurchaseMaterial({
                    userId: localStorage.getItem("userId"),
                    id: material.id,
                    materialName: material.materialName,
                    num: material.num,
                    unit: material.unit,
                    unitPrice: material.unitPrice,
                    totalPrice: material.totalPrice,
                    supplierId: material.supplierId,
                    supplier: supplierName,
                })
                : addPurchaseMaterial({
                    userId: localStorage.getItem("userId"),
                    orderNo: this.purchaseForm.orderNo,
                    materialName: material.materialName,
                    num: material.num,
                    unit: material.unit,
                    unitPrice: material.unitPrice,
                    totalPrice: material.totalPrice,
                    supplierId: material.supplierId,
                    supplier: supplierName,
                });

            request
                .then((response) => {
                    if (!material.id) {
                        material.id = response.data.id;
                    }
                    material.isEditing = false;
                    this.$message.success("原料信息保存成功");
                })
                .catch((error) => {
                    console.error("保存原料信息异常:", error);
                    this.$message.error("网络异常，保存失败");
                })
                .finally(() => {
                    this.$loading().close();
                });
        },
        // 发起采购-删除原料
        deleteMaterial(material, index) {
            if (!material.id) {
                this.purchaseMaterials.splice(index, 1);
                this.purchaseMaterials.forEach((item, i) => {
                    item.index = i + 1;
                });
                this.calculateOrderTotalPrice('edit');
                return;
            }

            this.$confirm("确定要删除该原料吗？", "确认删除", {
                type: "warning",
            })
                .then(() => {
                    this.$loading({ text: "正在删除原料..." });
                    deletePurchaseMaterial({
                        userId: localStorage.getItem("userId"),
                        id: material.id,
                    })
                        .then((response) => {
                            this.purchaseMaterials.splice(index, 1);
                            this.purchaseMaterials.forEach((item, i) => {
                                item.index = i + 1;
                            });
                            this.calculateOrderTotalPrice('edit');
                            this.$message.success(response.message || "原料删除成功");
                        })
                        .catch((error) => {
                            console.error("删除原料异常:", error);
                            this.$message.error("网络异常，删除失败");
                        })
                        .finally(() => {
                            this.$loading().close();
                        });
                })
                .catch(() => {
                    this.$message.info("已取消删除");
                });
        },
        // 发起采购-原料名称变化
        handleMaterialChange(material) {
            if (material.isEditing && material.materialName) {
                if (material.materialName === '面粉' || material.materialName === '香料') {
                    material.unit = "kg";
                } else {
                    material.unit = "g";
                }
            }
        },
        // 新增采购单-新增原料行
        addPurchaseMaterialRow() {
            const newIndex = this.addPurchaseMaterials.length + 1;
            const newMaterial = {
                index: newIndex,
                materialName: "",
                num: 0.1,
                unit: "g",
                unitPrice: 0.01,
                totalPrice: 0.01,
                supplierId: "",
            };
            this.addPurchaseMaterials.push(newMaterial);
            this.calculateOrderTotalPrice('add');
        },
        // 新增采购单-删除原料行
        removePurchaseMaterial(index) {
            if (this.addPurchaseMaterials.length <= 1) {
                this.$message.warning("至少保留一行原料");
                return;
            }
            this.addPurchaseMaterials.splice(index, 1);
            this.addPurchaseMaterials.forEach((item, i) => {
                item.index = i + 1;
            });
            this.calculateOrderTotalPrice('add');
        },
        // 提交新增采购单
        submitAddPurchase() {
            this.$refs.addPurchaseFormRef.validate((isValid) => {
                if (isValid) {
                    const hasEmptyField = this.addPurchaseMaterials.some(
                        (item) =>
                            !item.materialName ||
                            !item.num ||
                            !item.unit ||
                            !item.unitPrice ||
                            !item.supplierId
                    );
                    if (hasEmptyField) {
                        this.$message.error("请完善所有原料的信息（名称、数量、单位、单价、供应商）");
                        return;
                    }

                    this.addPurchaseMaterials.forEach(item => {
                        this.calculateTotalPrice(item);
                    });

                    this.$loading({ text: "正在创建采购单..." });
                    const params = {
                        ...this.addPurchaseForm,
                        orderDate: this.formatDate(this.addPurchaseForm.orderDate),
                        materialList: this.addPurchaseMaterials.map((item) => {
                            const supplier = this.suppliers.find(s => s.supplierId === item.supplierId) || {};
                            return {
                                materialName: item.materialName,
                                num: item.num,
                                unit: item.unit,
                                unitPrice: item.unitPrice,
                                totalPrice: item.totalPrice,
                                supplierId: item.supplierId,
                                supplier: supplier.supplierName || "",
                            };
                        }),
                        userId: localStorage.getItem("userId"),
                    };

                    addPurchaseOrder(params)
                        .then((response) => {
                            this.addPurchaseDialogVisible = false;
                            this.$message.success(response.message || "采购单新增成功");
                            // 新增后重新加载全量数据
                            this.fetchTaskList();
                        })
                        .catch((error) => {
                            console.error("新增采购单异常:", error);
                            this.$message.error("网络异常，创建失败");
                        })
                        .finally(() => {
                            this.$loading().close();
                        });
                }
            });
        },
        // 打开新增采购单抽屉
        openAddPurchaseDialog() {
            this.addPurchaseForm.orderNo = this.generateOrderNo();
            this.addPurchaseForm.orderDate = new Date();
            this.addPurchaseForm.deliveryTime = this.formatDate(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000));
            this.addPurchaseMaterials = [
                { index: 1, materialName: "", num: 0.1, unit: "g", unitPrice: 0.01, totalPrice: 0.01, supplierId: "" },
            ];
            this.calculateOrderTotalPrice('add');
            this.addPurchaseDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.addPurchaseFormRef?.clearValidate();
            });
        },
        // 生成订单编号
        generateOrderNo() {
            const date = new Date();
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const random = Math.floor(Math.random() * 10000).toString().padStart(4, "0");
            return `PO${year}${month}${day}${random}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.purchase-layout {
    display: flex;
    height: 100vh;
}

.main-content {
    flex: 1;
    padding: 20px;
    overflow: auto;
}

.task-search-form {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

::v-deep .el-pagination {
    margin-top: 20px;
}

/* 抽屉样式 */
::v-deep .material-drawer,
::v-deep .purchase-drawer,
::v-deep .add-purchase-drawer,
::v-deep .edit-purchase-drawer {
    z-index: 9999 !important;
}

::v-deep .material-drawer+.v-modal,
::v-deep .purchase-drawer+.v-modal,
::v-deep .add-purchase-drawer+.v-modal,
::v-deep .edit-purchase-drawer+.v-modal {
    z-index: 9998 !important;
}

/* 表格样式 */
::v-deep .purchase-drawer .el-table,
::v-deep .add-purchase-drawer .el-table,
::v-deep .edit-purchase-drawer .el-table {
    font-size: 14px;

    .el-table__cell {
        padding: 10px 15px;
    }
}

/* 标签样式 */
::v-deep .el-tag {
    margin-right: 0;
}

/* 表单样式 */
::v-deep .el-form-item {
    margin-bottom: 20px;
}

::v-deep .dialog-footer {
    text-align: right;
}
</style>